export default __webpack_public_path__ + "static/media/dummy.d42b7582.jpg";